import { LocalizedText, lt, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { copyToClipboard } from '@mews-commander/utils';
import { usePrivilege } from '@mews-commander/core';
import { useDeleteRateGroupConfirmationDialog } from '../../forms';

interface Props {
    rateGroupId: string;
}

export const RowActionCell = ({ rateGroupId }: Props) => {
    const { confirmationDialog, openConfirmationDialog } = useDeleteRateGroupConfirmationDialog({
        rateGroupId,
    });
    const canManageRateGroups = usePrivilege('manageRateGroups');
    return (
        <>
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <DropdownItem
                    label={<LocalizedText textKey={TextKey.CopyRateGroupId} />}
                    onClick={() => {
                        if (copyToClipboard(rateGroupId)) {
                            showSuccessAlert({ description: lt('CopiedSuccessMessage') });
                        }
                    }}
                />
                {canManageRateGroups ? (
                    <DropdownItem
                        label={<LocalizedText textKey={TextKey.Delete} />}
                        variant="danger"
                        onClick={openConfirmationDialog}
                    />
                ) : null}
            </DropDownButton>
            {confirmationDialog}
        </>
    );
};
